// @ts-nocheck
// @ts-ignore

import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import Cookies from "js-cookie";

import { Separator } from "@/components/ui/separator/separator";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/components/ui/radio-group/radio-group";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";

import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { convertUTCtoIST } from "@/utils";

import { fetchAllPerformanceReportOfEmployeeForAdminQueryOptions } from "@/config/queries/query-options";
import { useStatusFilter } from "./hooks/use-status-filter";
import { Button } from "@/components/ui/button/button";
import { DoubleArrowDownIcon } from "@radix-ui/react-icons";
import { Label } from "@/components/ui/label/label";

const OneEmployeePerformanceReportPageForAdmin = () => {
  const { filter, setFilter } = useStatusFilter();
  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;
  const [searchParams] = useSearchParams();

  const empName = searchParams.get("n");

  const { dateRange } = useDateRangeStore();

  // const startdate = dateRange?.from as Date;
  const startdate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.from as Date).setHours(0)).setMinutes(0)
    )
  );
  const enddate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.to as Date).setHours(23)).setMinutes(59)
    )
  );

  const { data, isPending, isFetching } = useQuery(
    fetchAllPerformanceReportOfEmployeeForAdminQueryOptions(key, {
      employee: empId,
      startdate,
      enddate,
      published: filter === "Published" ? true : false,
    })
  );

  console.log(data);

  const performanceReportData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.performanceReports === undefined) {
      return [];
    }

    const result = data?.performanceReports?.map((t) => {
      return {
        id: t?._id,
        deduction: t?.deduction,
        reasonPositive: t?.reasonPositive,
        reasonNegative: t?.reasonNegative,
        createdAt: t?.createdAt,
        date: t?.date,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">
          Performance Report of {empName}
        </h3>

        <div className="flex items-center gap-2">
          <Popover>
            <PopoverTrigger>
              <Button
                className="mr-3 flex items-center gap-2"
                size="sm"
                variant="outline"
              >
                <DoubleArrowDownIcon className="w-4 h-4" />
                Filter
                {filter && (
                  <>
                    <Separator orientation="vertical" />
                    {filter}
                  </>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <RadioGroup
                value={filter}
                onValueChange={(value: "Published" | "Not Published") => {
                  setFilter(value);
                }}
              >
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Published" id="published" />
                  <Label htmlFor="published">Published</Label>
                </div>
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Not Published" id="not_ublished" />
                  <Label htmlFor="not_published">Not Published</Label>
                </div>
              </RadioGroup>
            </PopoverContent>
          </Popover>

          <DateRangePicker />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        {/* <DataTable data={logsData} columns={columns} /> */}
      </div>
    </div>
  );
};

export default OneEmployeePerformanceReportPageForAdmin;
